import { renderElement } from "../../utils/use-render.js";
import { useControlsContext } from "./context.js";
import { forwardRef } from "react";
//#region src/ui/controls/backdrop.tsx
/**
* Presentational layer behind player controls. Renders a `<div>` with the controls state data attributes so skins can
* style it without reaching across sibling components.
*/
const ControlsBackdrop = forwardRef(function ControlsBackdrop({ render, className, style, ...elementProps }, forwardedRef) {
	const { state, stateAttrMap } = useControlsContext();
	return renderElement("div", {
		render,
		className,
		style
	}, {
		state,
		stateAttrMap,
		ref: [forwardedRef],
		props: [{
			role: "presentation",
			"aria-hidden": true
		}, elementProps]
	});
});
//#endregion
export { ControlsBackdrop };

//# sourceMappingURL=backdrop.js.map